import React from "react";
import { useSelector } from "react-redux";
import {
  getElementById,
  getContainerClass,
  getLabelStyles,
} from "../utils/styleUtils";

export const CustomTextarea = ({ instanceId, field, form, ...props }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Textarea element not found</div>;
  }

  const elementStyle = element.style || {};
  const labelPosition = elementStyle.labelPosition || "top";

  const handleTextareaChange = (e) => {
    if (field && form) {
      form.setFieldValue(field.name, e.target.value);
    }
  };

  const getTextareaStyles = () => {
    const baseStyles = {
      fontSize: elementStyle.fontSize || "0.875rem",
      padding: "0.5rem 0.75rem",
      borderRadius: elementStyle.borderRadius || "0.375rem",
      borderStyle: elementStyle.borderStyle || "solid",
      borderColor: elementStyle.borderColor || "#ced4da",
      backgroundColor: elementStyle.backgroundColor || "#FFFFFF",
      color: elementStyle.textColor || "#495057",
      resize: elementStyle.resize || "vertical",
      minHeight: elementStyle.rows ? `${elementStyle.rows * 1.5}rem` : "5rem",
      width: "100%",
      transition:
        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    };

    if (labelPosition === "left" || labelPosition === "right") {
      return {
        ...baseStyles,
        flex: "1 1 auto",
        minWidth: "0",
      };
    }

    return baseStyles;
  };

  return (
    <div className={getContainerClass(labelPosition)} style={{ width: "100%" }}>
      {elementStyle.label?.label && (
        <label
          htmlFor={`textarea-${instanceId}`}
          style={getLabelStyles(elementStyle, labelPosition)}
        >
          {elementStyle.label.label}
          {elementStyle.isRequired && (
            <span style={{ color: "#dc3545", marginLeft: "0.2rem" }}>*</span>
          )}
        </label>
      )}

      <textarea
        id={`textarea-${instanceId}`}
        placeholder={elementStyle.placeholderText || "Enter text here..."}
        value={field?.value || ""}
        onChange={handleTextareaChange}
        required={elementStyle.isRequired}
        minLength={elementStyle.minLength}
        maxLength={elementStyle.maxLength}
        rows={elementStyle.rows || 4}
        style={getTextareaStyles()}
        className="form-control"
        {...props}
      />

      {elementStyle.helpText && (
        <small className="text-muted mt-1" style={{ fontSize: "0.75rem" }}>
          {elementStyle.helpText}
        </small>
      )}

      {elementStyle.maxLength && (
        <small
          className="text-muted mt-1 d-block text-end"
          style={{ fontSize: "0.75rem" }}
        >
          {field?.value ? field.value.length : 0}/{elementStyle.maxLength}
        </small>
      )}
    </div>
  );
};
